import { Organization } from '../data/terra/Organization';

export default {
  DEFAULT_ORGANIZATION: {
    id: 1,
    shortName: "Teko",
    name: "Teko",
    createdAt: Date.now(),
    updatedAt: Date.now(),
  } as Organization
};
